<template>
  <tr>
    <th
      v-for="side in ['master', 'branch']"
      :key="side"
      :class="`${getFieldColorClass(side)}`"
      :data-testid="`change-${side}`"
    >
      <label>{{ field[side] !== null && field[side] !== undefined ? field.label : '' }}</label>
    </th>
  </tr>
  <!-- field is a simple text comparaison  -->
  <tr v-if="field.type === 'text'" class="compared-values">
    <th
      v-for="side in ['master', 'branch']"
      :key="side"
      :class="getFieldColorClass(side)"
      :data-testid="`change-${side}`"
    >
      <b-form-input v-if="!isValueEmpty(field[side])" disabled :model-value="field[side]" />
    </th>
  </tr>
  <!-- field is a list of text comparaison  -->
  <tr v-if="field.type === 'list'" class="compared-values">
    <th
      v-for="side in ['master', 'branch']"
      :key="side"
      :class="getFieldColorClass(side)"
      :data-testid="`change-${side}`"
    >
      <ul>
        <li v-for="(value, index) in field[side]" :key="index" :class="`${index !== 0 ? 'space-between-input' : ''}`">
          <b-form-input disabled :model-value="value" />
        </li>
      </ul>
    </th>
  </tr>
  <!-- field is list of key value comparaison   -->
  <tr v-if="field.type === 'map'" class="compared-values">
    <th
      v-for="side in ['master', 'branch']"
      :key="side"
      :class="getFieldColorClass(side)"
      :data-testid="`change-${side}`"
    >
      <ul>
        <li v-for="(value, index) in field[side]" :key="index" :class="`${index !== 0 ? 'space-between-input' : ''}`">
          <div class="map-container">
            <label v-b-tooltip.hover :title="value.key">{{ value.key }}:</label>
            <b-form-input disabled :model-value="value.value" />
          </div>
        </li>
      </ul>
    </th>
  </tr>
  <!-- field is a code comparaison  -->
  <tr v-if="field.type === 'code'" class="compared-values">
    <th colspan="2" v-if="field.master && field.branch" :class="getFieldColorClass('master')">
      <code-block-monaco :original="field.master" :modified="field.branch" />
    </th>
    <template v-else v-for="side in ['master', 'branch']" :key="side">
      <th :class="getFieldColorClass(side)" :data-testid="`change-${side}`">
        <code-block-monaco :original="field[side]" v-if="field[side]" />
      </th>
    </template>
  </tr>
  <!-- this field is a checkbox -->
  <tr v-if="field.type === 'checkbox'" class="compared-values">
    <th
      v-for="side in ['master', 'branch']"
      :key="side"
      :class="getFieldColorClass(side)"
      :data-testid="`change-${side}`"
    >
      <tc-switch :model-value="field[side]" disabled :data-testid="field.label" v-if="!isValueEmpty(field[side])" />
    </th>
  </tr>
  <!-- this field is a list of label and checkbox -->
  <tr v-if="field.type === 'map-checkbox'" class="compared-values">
    <th
      v-for="side in ['master', 'branch']"
      :key="side"
      :class="getFieldColorClass(side)"
      :data-testid="`change-${side}`"
    >
      <ul>
        <li v-for="(value, index) in field[side]" :key="index" :class="`${index !== 0 ? 'space-between-input' : ''}`">
          <div class="map-container">
            <label>{{ value.key }}:</label>
            <tc-switch :model-value="value.value" :data-testid="`${index}-${field.label}`" disabled />
          </div>
        </li>
      </ul>
    </th>
  </tr>
  <!-- this field is a title -->
  <tr v-if="field.type === 'title'" class="compared-values">
    <th
      v-for="side in ['master', 'branch']"
      :key="side"
      :class="`${getFieldColorClass(side)}`"
      :data-testid="`change-${side}`"
    >
      <h5 v-if="field[side]">{{ field[side] }}</h5>
    </th>
  </tr>
</template>

<script setup>
import CodeBlockMonaco from '@components/containers/code-block-monaco.vue';
import TcSwitch from '@components/forms/tc-switch';

const props = defineProps({
  field: Object,
  statusBranch: String,
  statusMaster: String,
});

const getFieldColorClass = side => {
  const status = side === 'master' ? props.statusMaster : props.statusBranch;
  switch (status) {
    case 'created':
      return 'bg-created';
    case 'deleted':
    case 'trashed':
      return 'bg-deleted';
    default:
      return '';
  }
};

const isValueEmpty = value => {
  return value === null || value === undefined || value === '';
};
</script>
<style lang="scss" scoped>
@import '@styles/variables.scss';

.compared-values th {
  padding-bottom: 0.5em;
}

tr {
  & th:first-child {
    border-right: 1px solid;
    border-color: $border-color;
    padding-right: 1em;
  }

  & th:nth-child(2) {
    padding-left: 1em;
  }

  & th:first-child[colspan] {
    border-right: none;
    padding-right: 0;
  }
}

th {
  width: 50%;
  vertical-align: top;
  padding: 0 1em;
}

ul {
  margin-left: 1.5em;
  margin-bottom: 0;
  padding: 0;
}

.map-container {
  display: flex;
  justify-content: space-between;
  gap: 1em;
  align-items: center;
  > label {
    width: 50%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0px;
  }
}

.visibility-hidden {
  visibility: hidden;
}

.side-by-side-view-container > div:first-child {
  border-right: 1px solid $border-color;
  padding-right: 1em;
  margin-right: 1em;
}

.space-between-input {
  margin-top: 1em;
}

.bg-created {
  background-color: rgb(0, 255, 0, 0.05);
}

.bg-deleted {
  background-color: rgb(255, 0, 0, 0.05);
}
</style>
